import useNumericParams from '@hooks/useNumericParams'
import useReduxAction from '@hooks/useReduxAction'

import CutterProfileEditRoutes from './routes'

const CutterProfileEdit = () => {
  const { cutterProfileId } = useNumericParams()

  useReduxAction(
    'cutterProfiles',
    'loadCutterProfile',
    {
      entityId: cutterProfileId,
    },
    [cutterProfileId],
    {
      dispatchAction: (action, requestOptions) => action(cutterProfileId, requestOptions),
      shouldPerformFn: ({ loading }) => !!cutterProfileId && !loading,
    },
  )

  return (
    <CutterProfileEditRoutes />
  )
}

export default CutterProfileEdit
